if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      var bogo_less_pd = $('.cart-item[data-bogo="false"]').length;

//if($(this).hasClass('bundle_product_add')){

  var data_type = $(this).parents('.bundle-product-list').find('.product-form__buttons button').attr('data_type');

  var data_variant = $(this).parents('.main-bundle-product-container').attr('data-variant');
  var id = parseInt($(this).parents('.bundle-product-list').find('.product-form__buttons button').attr('data_id'));
  var discount = $(this).parents('.bundle-product-list').find('.product-form__buttons button').attr('bundle_disconut');
  var jsonobj = [];
    if( $('.cart-item[data_type="'+data_type+'"][data-type="bundle_product"]').length > 0 ){
    $('.cart-item[data_type="'+data_type+'"][data-type="bundle_product"]').each(function(){
    rendom_no = $(this).attr('data-item-random');
    var item = {}
    item ["id"] = parseInt(id);
    item ["quantity"] = 1;
    item ['properties']={'_random_no': rendom_no,'_bundle_off': discount,_bundle_products:true};
    jsonobj.push(item);
      $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: { items: jsonobj},
      dataType: 'json',
      async: false,
      success: function (data) { 
            }
        });
     });
   }
   else{
    $('.cart-item[data_type="'+data_type+'"]').each(function(){
    var man_id = $(this).attr('data-id');
    var data_key =  $(this).attr('data-key');
    rendom_no = (Math.random().toString(36)+'00000000000000000').slice(2, 10+2);
    var item_main={}
    item_main ["id"] = parseInt(man_id);
    item_main ["quantity"] = 1;
    item_main ['properties']={'_random_no': rendom_no,'_product_type':'bundle_product'};
     jsonobj.push(item_main);
    var  item = {}
    item ["id"] = parseInt(id);
    item ["quantity"] = 1;
    item ['properties']={'_random_no': rendom_no,'_bundle_off':discount,'_bundle_products':true,};
    jsonobj.push(item);
    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: { items: jsonobj},
      dataType: 'json',
      async: false,
      success: function (data) { 

      item_main ["quantity"] = 0;
      item ["quantity"] = 0;
      $.ajax({
      type: "POST",
      url: '/cart/change.js',
      data: {id: data_key,quantity:0},
      dataType: 'json',
      async: false,
      success: function (data) {
 
             }
       }); 
     }
   }); 
  }); 
}
//}

      if($(this).parents().hasClass('quick-add-modal')){
     $(this).parents('.quick-add-modal').find('.bogo_product').attr('disabled','disabled');
   }
      if(window.location.href.indexOf("product") > -1){
      var rendom_no = (Math.random().toString(36)+'00000000000000000').slice(2, 10+2);
      $(this).parents('.product__info-wrapper.grid__item').find('product-form .main_pd_random_no').val(rendom_no); 
      $(this).parents('.product__info-wrapper.grid__item').find('product-form .bogo_random_no_1').val(rendom_no);
      $(this).find('.random_no').val(rendom_no);
      $(this).find('.random_no1').val(rendom_no);
      $(this).find('.random_no2').val(rendom_no);
      $(this).find('.random_no3').val(rendom_no);
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
     
      if(window.location.href.indexOf("product") > -1){
   
      if( $('.monogram-section').length >0){
        if($('#monogram-logo').length >0){
       var monogra_logo = $('#monogram-logo').val().length;
          }
        if($('.rd-mgl-content-inner .rd-mgl-field #rd-mgl-input').length > 0){
        var monogra_text = $('.rd-mgl-content-inner .rd-mgl-field #rd-mgl-input').val().length;
          }
       var  pro_id = $('.model.monogram-section-popup').attr('data-id');
        var qty =  $('.product-form__input.product-form__quantity .quantity__input').val();
        if(monogra_logo > 0 || monogra_text > 0 ){
       $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data:{
        quantity: qty,
        id: 30672622157893
              },
        dataType: 'json',
    async: false,
    success: function (data) { 
    $('.rd-mgl-tab-content-text input#rd-mgl-input').val('');
    $('.rd-mgl-tab-content-text .rd-mgl-preview-overlay p').html('ABC');
    $('.rd-mgl-tab-content-logo input#monogram-logo').val('');
    $('.rd-mgl-logo-txt').removeClass('is-active');
    $('span.rd-mgl-logo-txt.type-default').addClass('is-active');
 } 
 });
        }
      }
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
            var flag = 0;
            $('.cart-item').each(function(){
                
            if($(this).attr('data-meta-bundle')=='false' && !$(this).attr('data-item-random') && $(this).attr('data_type') != 'Mobile Case'){
               flag =1 
            }   
            })
            if(flag == 0 ){
                $('.main-product-type-bundle').addClass('hide_bndl');
            }else if (flag =1 ){
             $('.main-product-type-bundle').removeClass('hide_bndl');
            }

            })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            var hide_mobile_bundle_pd = $('cart-drawer .grid__item.bundle-product-list.cart-hidden').length
            var hide_bundle_pd =$('cart-drawer .main_bundle_wraoer-container li.grid__item.bundle-product-list.cart-hidden').length
            var total_hide_bundle_pd = hide_mobile_bundle_pd+hide_bundle_pd;
  
            var total_mobile_bundle_pd = $('cart-drawer .grid__item.bundle-product-list').length;
            var total_bundle_pd = $('cart-drawer .main_bundle_wraoer-container li.grid__item.bundle-product-list').length;
            var total_bundle_pd_main = total_mobile_bundle_pd+total_bundle_pd;
            var total_show_pd = total_bundle_pd_main-total_hide_bundle_pd;

            if(total_show_pd < 1){
                $('cart-drawer .drawer_upsells').addClass('hide_active');
            }else{
            
                 $('cart-drawer .drawer_upsells').removeClass('hide_active');
            }
        });
          
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}